import logo from "../img/icon/logo_circwear_without_text.png";
const Nav = ({authToken, setShowModal,showModal,isSignUp,setIsSignUp,isLoggedIn}) => {
    const handleClick = () =>{
        setShowModal(true)
        setIsSignUp(false)
    }

    return(
        <nav>
            <div className="logo-container">
                <img className="logo" src={logo}/>
            </div>

            {!authToken && !isLoggedIn &&( <button
                className="login-button"
                onClick={handleClick}
                disabled={!isSignUp}
            >Einloggen</button>)}
        </nav>
    )
}
export default Nav